export default "__VITE_ASSET__exECayCu__"